import { render, staticRenderFns } from "./ImportarDescentralizacoes.vue?vue&type=template&id=e2cc45be&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./ImportarDescentralizacoes.vue?vue&type=style&index=0&id=e2cc45be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cc45be",
  null
  
)

export default component.exports